/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day_number: NonNullable<unknown> }} Which_DayInputs */

const en_which_day = /** @type {(inputs: Which_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Day ${i?.day_number}`)
};

const ar_which_day = /** @type {(inputs: Which_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`اليوم ${i?.day_number}`)
};

const de_which_day = /** @type {(inputs: Which_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tag ${i?.day_number}`)
};

const es_which_day = /** @type {(inputs: Which_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Día ${i?.day_number}`)
};

const fr_which_day = /** @type {(inputs: Which_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jour ${i?.day_number}`)
};

const it_which_day = /** @type {(inputs: Which_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Giorno ${i?.day_number}`)
};

const ja_which_day = /** @type {(inputs: Which_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day_number}日目`)
};

const ko_which_day = /** @type {(inputs: Which_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day_number}일차`)
};

const pt_br_which_day = /** @type {(inputs: Which_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dia ${i?.day_number}`)
};

const ru_which_day = /** @type {(inputs: Which_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`День ${i?.day_number}`)
};

const th_which_day = /** @type {(inputs: Which_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`วันที่ ${i?.day_number}`)
};

const tr_which_day = /** @type {(inputs: Which_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gün ${i?.day_number}`)
};

const zh_cn_which_day = /** @type {(inputs: Which_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.day_number} 天`)
};

const zh_tw_which_day = /** @type {(inputs: Which_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.day_number} 天`)
};

/**
* | output |
* | --- |
* | "Day {day_number}" |
*
* @param {Which_DayInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const which_day = /** @type {((inputs: Which_DayInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Which_DayInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_which_day(inputs)
	if (locale === "ar") return ar_which_day(inputs)
	if (locale === "de") return de_which_day(inputs)
	if (locale === "es") return es_which_day(inputs)
	if (locale === "fr") return fr_which_day(inputs)
	if (locale === "it") return it_which_day(inputs)
	if (locale === "ja") return ja_which_day(inputs)
	if (locale === "ko") return ko_which_day(inputs)
	if (locale === "pt_br") return pt_br_which_day(inputs)
	if (locale === "ru") return ru_which_day(inputs)
	if (locale === "th") return th_which_day(inputs)
	if (locale === "tr") return tr_which_day(inputs)
	if (locale === "zh_cn") return zh_cn_which_day(inputs)
	return zh_tw_which_day(inputs)
});